import { render, staticRenderFns } from "./gameserverlist.vue?vue&type=template&id=5fa845f7&scoped=true"
import script from "./gameserverlist.vue?vue&type=script&lang=js"
export * from "./gameserverlist.vue?vue&type=script&lang=js"
import style0 from "./gameserverlist.vue?vue&type=style&index=0&id=5fa845f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa845f7",
  null
  
)

export default component.exports